import React, { useState, useEffect } from "react";
import AuthLayout from "./AuthLayout";
import { Row, Col, Input, Button, Form } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { LoadingOutlined, CloseCircleOutlined } from "@ant-design/icons";
import {
  ResetNewPassword,
  ValidateEmailToken,
} from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { ResetPasswordCredentialsSchema } from "../validattion";

const ResetPassword = (props) => {
  const { ResetNewPassword, ValidateEmailToken } = props;
  const [resetload, setResetload] = useState(false);
  const [checktoken, setCheckToken] = useState(false);
  const [checktoken2, setCheckToken2] = useState(false);
  const history = useHistory();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
  } = useForm({
    resolver: yupResolver(ResetPasswordCredentialsSchema),
  });
  const { uid, token } = useParams();

  const resetPassword = async (data) => {
    const obj = {
      new_password1: data?.password1,
      new_password2: data?.password2,
      uid,
      token,
    };
    setResetload(true);
    const res = await ResetNewPassword(obj);
    if (res.success) {
      toast.success("Password Reset Successfully, Please login to continue", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        history.push("/auth/login");
      }, 2000);
      setResetload(false);
    } else {
      setResetload(false);
      const { data } = res.message;
      toast.error(`${data}` || "Something went wrong", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // useEffect(() => {
  //   const checkTokenEmail = async () => {
  //     const getToken = {
  //       token,
  //     };
  //     setCheckToken(true);
  //     setCheckToken2(true);
  //     const res = await ValidateEmailToken(getToken);
  //     if (res.success) {
  //       setCheckToken(false);
  //     } else {
  //       setCheckToken(true);
  //       setCheckToken2(false);
  //     }
  //   };
  //   checkTokenEmail();
  // }, [ValidateEmailToken, token]);
  const styles = {
    marginTop: "4rem",
  };
  return (
    <>
      <AuthLayout
        style={styles}
        fadeName="fade-left"
        pageTitle="Reset Password"
      >
        <Form onFinish={handleSubmit(resetPassword)} autoComplete="off">
          <div className="auth-title" style={{ marginBottom: "20px" }}>
            <h2>Reset Password</h2>
            <p>Enter your new password</p>
          </div>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <Controller
                  name="password1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Input.Password
                      placeholder="Enter New Password"
                      {...field}
                    />
                  )}
                />
                <small className="text-danger">
                  {errors.password1 && (
                    <span className="error">{errors?.password1?.message}</span>
                  )}
                </small>
              </div>
            </Col>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <Controller
                  name="password2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Input.Password
                      placeholder="Confirm New Password"
                      {...field}
                    />
                  )}
                />
                <small className="text-danger">
                  {errors.password2 && (
                    <span className="error">{errors?.password2?.message}</span>
                  )}
                </small>
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <Button
                loading={resetload}
                block
                disabled={checktoken}
                htmlType="submit"
                type="primary"
              >
                {resetload ? "Processing..." : "RESET PASSWORD"}
              </Button>
            </Col>
          </Row>
        </Form>
        {/* </>
        )} */}
      </AuthLayout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  ResetNewPassword,
  ValidateEmailToken,
})(ResetPassword);
